<template>
  <div :class="{ 'forcast-zhiyun-version': versionConfig.ZHIYUN_VERSION }">
    <a-form
      layout="inline"
      :form="form"
      @submit="handleSubmit"
      style="margin-bottom:10px"
    >
      <a-form-item label="日期段">
        <a-range-picker
          ref="myData1"
          v-decorator="[
            'dateRange',
            {
              rules: [
                {
                  required: true,
                  message: '请选择日期段!'
                }
              ],
              initialValue: defaultDateRange
            }
          ]"
          :placeholder="['开始日期', '结束日期']"
        />
      </a-form-item>
      <a-form-item>
        <a-select
          style="width: 120px"
          v-decorator="[
            'dateSelect',
            {
              initialValue: defaultRoomType
            }
          ]"
        >
          <a-select-option
            v-for="(item, index) in selectData"
            :key="index"
            :value="item.Id"
            >{{ item.Text }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-checkbox
          @change="onChangeSaleble"
          v-decorator="[
            'onlyShowSaleable',
            {
              initialValue: false
            }
          ]"
          >仅显示可卖</a-checkbox
        >
      </a-form-item>
      <a-form-item>
        <a-button type="primary" html-type="submit" :loading="loadingState">
          查询
        </a-button>
      </a-form-item>
    </a-form>
    <a-layout class="prediction-layout">
      <a-layout>
        <a-layout-content>
          <a-table
            class="forcast-table"
            :columns="columns"
            :dataSource="data"
            :pagination="pagination"
            :loading="loading"
            bordered
            size="small"
            :scroll="scrollArray"
            :height="scrollArray.y"
          >
          </a-table>
        </a-layout-content>
      </a-layout>
      <a-layout-sider
        theme="light"
        :reverseArrow="true"
        v-model="collapsed"
        collapsible
        :collapsedWidth="0"
        :width="250"
      >
        <div class="side-title">{{ sideTitle }}</div>
        <data-grid
          ref="dataGrid"
          :columns="tableColumns"
          :data="tableData"
          :pagination="false"
          :props="props"
          bordered
        >
        </data-grid>
      </a-layout-sider>
    </a-layout>
  </div>
</template>

<script>
import { DataGrid } from "@/components/dataGrid";
import moment from "moment";
import { cache } from "@/utils/common";
import cloneDeep from "lodash/cloneDeep";
import {
  OrderDetailModal,
  TeamOrderDetailModal
} from "@/views/orderManage/funtion.js";
moment.locale("zh-cn");
// const renderContent = (value, row) => {
//   const onClick = {
//     click: () => {
//       this.collapsed = true;
//     }
//   };
//   const str = <div {...{ on: onClick }}>{value}</div>;
//   const obj = {
//     children: str,
//     attrs: {}
//   };
//   if (row.title) {
//     obj.attrs.colSpan = 0;
//   }
//   return obj;
// };
export const PREDICTIROOMINFOTYPES = {
  Leaving: "3", //预离
  Booking: "2", //预入
  CheckIn: "1" //在住
};
export const PREDICTIROOMINFO = {
  3: "预离", //预离
  2: "预订", //预入
  1: "在住" //在住
};
export default {
  components: { DataGrid },
  name: "RoomoreForcast",
  data() {
    return {
      // eslint-disable-next-line no-undef
      versionConfig,
      data: [],
      selectData: [],
      pagination: false,
      loading: false,
      columns: [],

      //搜索框默认值
      defaultRoomType: "",
      defaultDateRange: [],

      scrollArray: { x: 200, y: 900 },
      loadingState: false,
      form: this.$form.createForm(this),
      collapsed: true,
      tableData: [],
      sideTitle: "",
      tableColumns: [
        {
          title: "订单号",
          dataIndex: "OrderNo",
          width: 70,
          customRender: (text, record) => {
            if (record.OrderId > 0) {
              const orderDetail = {
                click: () => {
                  this.orderDetail(record);
                }
              };
              return (
                <a-button type="link" size="small" {...{ on: orderDetail }}>
                  {text}
                </a-button>
              );
            }
          }
        },
        {
          title: "订单信息",
          dataIndex: "RoomNo",
          width: 100,
          align: "left",
          customRender: (text, record) => {
            return (
              <div>
                {record.RoomNo}/{record.Contact}
              </div>
            );
          }
        },
        {
          title: "状态",
          dataIndex: "StatusName",
          width: 60
        },
        {
          title: "房型",
          dataIndex: "RoomType"
        }
      ],
      props: {
        scroll: {
          x: 400,
          y: "calc(100vh - 330px)"
        }
      },
      defaultItem: {},
      defaultData: {}
    };
  },
  created() {
    const _this = this;

    //默认当前日期为缓存的账务日期，之后日期为当前日期+14天
    var nowDate = cache.get("user").AccountDate;
    // let afterDay = this.GetDateStr(14);
    let afterDay = moment(nowDate).add(14, "days");
    //设置搜索框日期的初始值
    this.defaultDateRange = [moment(nowDate, "YYYY-MM-DD"), afterDay];

    //或缺搜索框的下拉内容
    this.$post("Common_GetSelect", { Types: "RoomType" }).then(res => {
      _this.selectData = res.Data.RoomType;
      //在下拉内容加入全选选项
      _this.selectData.unshift({ Id: "", Text: "全部" });

      //将初始化数据传入初始化函数
      let item = {
        StartDate: nowDate,
        EndDate: afterDay,
        RoomTypeId: ""
      };
      _this.init(item);
    });
    this.getDefaultItem();
  },
  methods: {
    //获取系统参数值
    getDefaultItem() {
      this.$post("Room_GetDefaultTime", {}).then(res => {
        res.Data.SystemConstList.forEach(item => {
          this.defaultItem[item.Code] = item.Value;
        });
      });
    },
    init(postData) {
      const _this = this;

      //计算表格的宽高滚动值，高度值固定。宽度初始值为200，为固定部分宽度

      //获取固定日期段的房态预测数据
      _this.$post("PredictRoomStatus_List", postData).then(res => {
        if (res.Data.Details == "") {
          this.$message.error("无数据");
          _this.loadingState = false;
          return;
        }
        _this.loadingState = false;
        this.defaultData = res.Data;
        _this.setTableData();
      });
    },
    setTableData() {
      const { defaultData } = this;
      const baseData = cloneDeep(defaultData);
      const _this = this;
      _this.scrollArray.y = document.body.clientHeight - 120;
      _this.scrollArray.x = 200;
      //拼凑下4行额外数据，总计，出租率，房费预测，平均房价
      var countOut = {
        RoomTypeName: "总计",
        RoomTypeId: "-1",
        Quantity: 0,
        PredictCalendars: []
      };
      var ratArray = { title: "出租率" };
      var priceArray = { title: "房费预测" };
      var balancePriceArray = { title: "平均房价" };

      //获取总统计值数组
      var summaryData = baseData.DataSummary;
      const onlyShowSaleable = this.form.getFieldsValue().onlyShowSaleable;
      //遍历总统计值数组，将数据填入对应数组
      for (let n = 0; n < summaryData.length; n++) {
        countOut.PredictCalendars.push(summaryData[n]);
        let field = "CheckIn";
        if (onlyShowSaleable) {
          field = "Saleable";
        }
        ratArray[field + summaryData[n].Date] = summaryData[n].RentRate;
        priceArray[field + summaryData[n].Date] =
          summaryData[n].PredictRoomPrice;
        balancePriceArray[field + summaryData[n].Date] =
          summaryData[n].AvgRoomPrice;
      }

      //获取日历具体数据
      var PredictRoomData = baseData.Details;
      //讲总计数据填入日历具体数据
      PredictRoomData.push(countOut);

      //遍历日历具体数据，将日历内日期与数值拼合放在数组最外层
      for (let l = 0; l < PredictRoomData.length; l++) {
        //当房型名称不是总计时，计算总值
        const info = PredictRoomData[l];
        if (info.RoomTypeName != "总计") {
          countOut.Quantity += info.Quantity;
        }
        for (let m = 0; m < (info.PredictCalendars || []).length; m++) {
          const el = info.PredictCalendars[m];
          let obj = {};
          el.PredictRoomInfos.forEach(item => {
            if (!obj[item.PredictRoomInfoTypes]) {
              obj[item.PredictRoomInfoTypes] = [item];
            } else {
              obj[item.PredictRoomInfoTypes].push(item);
            }
          });
          el.PredictRoomInfosObj = obj;
          for (let k in info.PredictCalendars[m]) {
            info[k + info.PredictCalendars[m].Date] =
              info.PredictCalendars[m][k];
          }
        }
      }
      PredictRoomData.push(ratArray);
      PredictRoomData.push(priceArray);
      PredictRoomData.push(balancePriceArray);

      //当数据不为空时，开始拼接表头
      if (PredictRoomData != "") {
        var dateForm = PredictRoomData[0].PredictCalendars;
        _this.columns = [
          {
            title: "房型",
            dataIndex: "RoomTypeName",
            align: "center",
            width: 200,
            fixed: "left",
            customRender: (value, row, index) => {
              if (index < PredictRoomData.length - 3) {
                return {
                  children: value,
                  attrs: {
                    style:
                      "overflow: hidden;white-space: nowrap;text-overflow: ellipsis;max-width:200px;text-align: center;"
                  }
                };
              } else {
                return {
                  children: row.title,
                  attrs: { colSpan: 2 }
                };
              }
            }
          },
          {
            title: "总数",
            dataIndex: "Quantity",
            align: "center",
            width: 50,
            fixed: "left",
            customRender: (e, row) => {
              let obj = {};
              if (row.title && onlyShowSaleable) {
                obj.colSpan = 0;
              }
              return this.renderContent(e, row, obj);
            }
          }
        ];
        for (let i = 0; i < dateForm.length; i++) {
          const width = onlyShowSaleable ? 100 : 250;
          _this.scrollArray.x += width;
          let item = {
            title: dateForm[i].Date + "  " + dateForm[i].Week,
            customRender: (value, row, index) => {
              if (index < PredictRoomData.length - 3) {
                return {
                  children: value,
                  attrs: { style: "border:1px solid red" }
                };
              } else {
                return {
                  children: row.title,
                  attrs: { style: "border:1px solid blue" }
                };
              }
            },
            children: onlyShowSaleable
              ? [
                  {
                    title: "可卖",
                    dataIndex: "Saleable" + dateForm[i].Date,
                    align: "center",
                    width: 100,
                    customRender: (e, row, index) => {
                      let style =
                        "color:#0c2546;font-weight:normal;background:#fff";
                      if (index < PredictRoomData.length - 3) {
                        style =
                          "color:#027492;font-weight:bold;background:#fff";
                      }
                      return this.renderContent(e, row, {
                        style: style
                      });
                    }
                  }
                ]
              : [
                  {
                    title: "在住",
                    dataIndex: "CheckIn" + dateForm[i].Date,
                    align: "center",
                    width: 50,
                    customRender: (text, record, index) =>
                      this.renderCellContent({
                        text,
                        record,
                        index,
                        code: "CheckIn",
                        date: dateForm[i].Date,
                        title: "在住"
                      })
                  },
                  {
                    title: "预订",
                    dataIndex: "Booking" + dateForm[i].Date,
                    align: "center",
                    width: 50,
                    customRender: (text, record, index) =>
                      this.renderCellContent({
                        text,
                        record,
                        index,
                        code: "Booking",
                        date: dateForm[i].Date,
                        title: "预订"
                      })
                  },
                  {
                    title: "可卖",
                    dataIndex: "Saleable" + dateForm[i].Date,
                    align: "center",
                    width: 50,
                    customRender: (e, row) => {
                      return this.renderContent(e, row, {
                        style:
                          "color:#027492;font-weight:bold;background:#ffffe1"
                      });
                    }
                  },
                  {
                    title: "维修",
                    dataIndex: "Repair" + dateForm[i].Date,
                    align: "center",
                    width: 50,
                    customRender: this.renderContent
                  },
                  {
                    title: "预离",
                    dataIndex: "Leaving" + dateForm[i].Date,
                    align: "center",
                    width: 50,
                    customRender: (text, record, index) =>
                      this.renderCellContent({
                        text,
                        record,
                        index,
                        code: "Leaving",
                        date: dateForm[i].Date,
                        title: "预离"
                      })
                  }
                ]
          };
          _this.columns.push(item);
        }
      }
      if (_this.scrollArray.x < document.body.clientWidth) {
        delete _this.columns[0].fixed;
        delete _this.columns[1].fixed;
      }
      _this.data = PredictRoomData;
    },
    renderContent(value, row, attrs) {
      const onClick = {
        click: () => {
          this.collapsed = true;
        }
      };
      const str = <div {...{ on: onClick }}>{value}</div>;

      const obj = {
        children: str,
        attrs: {
          ...attrs
        }
      };
      const onlyShowSaleable = this.form.getFieldsValue().onlyShowSaleable;
      if (row.title && !onlyShowSaleable) {
        obj.attrs.colSpan = 0;
      }
      return obj;
    },
    renderCellContent({ text, record, index, code, date, title }) {
      let str = text;
      const onClick = {
        click: () => {
          if (text) {
            const keyCode = PREDICTIROOMINFOTYPES[code];
            this.tableData =
              (record["PredictRoomInfosObj" + date] || {})[keyCode] || [];
            if (this.tableData && this.tableData.length > 0) {
              this.collapsed = false;
              this.sideTitle = `${record.RoomTypeName}【${title}】`;
            } else {
              this.collapsed = true;
              this.sideTitle = "";
            }
          } else {
            this.collapsed = true;
            this.sideTitle = "";
          }
        }
      };
      str = (
        <div class="cell-link" {...{ on: onClick }}>
          {text}
        </div>
      );

      if (code == "CheckIn") {
        if (index < this.data.length - 3) {
          return {
            children: str,
            attrs: {}
          };
        } else {
          return {
            children: str,
            attrs: { colSpan: 5 }
          };
        }
      } else {
        const obj = {
          children: str,
          attrs: {}
        };
        if (record.title) {
          obj.attrs.colSpan = 0;
        }
        return obj;
      }
    },
    onChangeSaleble() {
      this.$nextTick(() => {
        this.setTableData();
      });
    },
    //提交表单的内容，开始搜索初始化表格
    handleSubmit(e) {
      var _this = this;
      e.preventDefault();
      _this.form.validateFields((err, values) => {
        if (!err) {
          _this.loadingState = true;

          let item = {
            StartDate: moment(values.dateRange[0]).format("YYYY-MM-DD"),
            EndDate: moment(values.dateRange[1]).format("YYYY-MM-DD"),
            RoomTypeId: values.dateSelect
          };
          if (values.dateSelect == "") {
            item.RoomTypeId = "";
          }
          _this.init(item);
        }
      });
    },
    //用于计算输入日期+输入日期的值后的日期
    GetDateStr(AddDayCount) {
      var dd = new Date();
      dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期
      var y = dd.getFullYear();
      var m =
        dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1; //获取当前月份的日期，不足10补0
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0
      return y + "-" + m + "-" + d;
    },
    orderDetail(record) {
      if (this.defaultItem.PlusHotelOrderModel == 1) {
        TeamOrderDetailModal({
          orderId: record.OrderId
        });
      } else {
        OrderDetailModal({
          orderId: record.OrderId
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-table td {
  white-space: nowrap;
  text-align: center;
}
.forcast-table /deep/.ant-table-thead {
  tr {
    th {
      background: rgb(16, 150, 184) !important;
      color: #fff;
    }
    &:first-child {
      th:nth-child(2) {
        font-size: 16px;
      }
    }
  }
}
.forcast-table /deep/.ant-table-tbody > tr {
  td {
    color: #000;
  }
  td:nth-child(2) {
    color: #0988a9;
    font-size: 16px;
    font-weight: bold;
  }
  td:nth-child(10n + 3),
  td:nth-child(10n + 4),
  td:nth-child(10n + 5),
  td:nth-child(10n + 6),
  td:nth-child(10n + 7) {
    background: rgba(211, 234, 255, 0.36);
  }
  &:last-child,
  &:nth-last-child(2),
  &:nth-last-child(3) {
    td {
      background: #fff;
      color: #0988a9;
      font-size: 16px;
      font-weight: normal;
    }
    td:nth-child(2n + 2) {
      background: rgba(211, 234, 255, 0.36);
    }
    td:first-child {
      color: #0988a9;
      font-weight: bold;
      font-size: 15px;
    }
  }
}

.forcast-zhiyun-version {
  .forcast-table/deep/ .ant-table-thead tr th {
    background: #5b7eab !important;
  }
  .forcast-table /deep/.ant-table-tbody > tr {
    td {
      color: #000;
    }
    td:nth-child(2) {
      color: #0c2546;
      font-size: 16px;
      font-weight: bold;
    }
    td:nth-child(10n + 3),
    td:nth-child(10n + 4),
    td:nth-child(10n + 5),
    td:nth-child(10n + 6),
    td:nth-child(10n + 7) {
      background: rgba(238, 247, 255, 0.36);
    }
    &:last-child,
    &:nth-last-child(2),
    &:nth-last-child(3) {
      td {
        background: #fff;
        color: #0c2546;
        font-size: 16px;
        font-weight: normal;
      }
      td:nth-child(2n + 2) {
        background: rgba(238, 247, 255, 0.36);
      }
      td:first-child {
        color: #0c2546;
        font-weight: bold;
        font-size: 15px;
      }
    }
  }
}
.prediction-layout {
  /deep/.ant-layout {
    padding: 0 !important;
  }
  /deep/.ant-layout-sider-zero-width-trigger {
    top: 40%;
  }
  /deep/.ant-layout-sider-light .ant-layout-sider-zero-width-trigger {
    color: #acacac;
    background: #a3a3a330;
  }
  /deep/.ant-layout-sider-light {
    background: #fafafa;
  }
}
.side-title {
  background: #1096b8;
  padding: 3px 5px;
  color: #fff;
}
.forcast-zhiyun-version {
  .side-title {
    background: #5b7eab;
  }
}
.cell-link {
  cursor: pointer;
  &:hover {
    color: #f60;
  }
}
</style>
